import BaseComponent from "../../baseComponent.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import DashboardService from "../../../core/services/dashboardService.js";
import styles from "../../common/tab.scss";

export default class SharedTab extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    $(this.refs.tab).hover(() => {
      $(this.refs.actions).stop().fadeIn(200);
    }, () => {
      $(this.refs.actions).stop().fadeOut(200);
    });
  }

  remove() {
    this.publish(InternalEvent.App.SHOW_APP_MODAL, {
      onAgree: () => {
        DashboardService.deleteSharedDashboard(this.props.tab.persistenceId)
          .then(() => {
            this.props.onDelete();
          });
      },
      header: "Do you really want to remove?"
    });
  }

  handleDragStart(e) {
    $(this.refs.actions).hide();
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("data", JSON.stringify({
      dashboardId: this.props.tab.persistenceId,
      position: this.props.tab.tabPosition,
      type: "shared"
    }));
  }

  handleDrop(e) {
    e.preventDefault();
    let data = JSON.parse(e.dataTransfer.getData('data'));
    if (data.type && data.type === "shared") {
      if (this.props.tab.tabPosition !== data.position) {
        this.props.onDrop(data.dashboardId, this.props.tab.tabPosition, data.position, true);
      }
    }
  }

  preventDefault(e) {
    e.preventDefault();
  }

  handleDragEnter(e) {
    const type = e.target.attributes["data-type"];
    if (type && type.value !== "shared") {
      e.dataTransfer.dropEffect = "none";
    }
  }

  handleDragLeave() {
  }

  handleDragEnd() {
  }

  render() {
    let titleStyle = this.props.tab.activated ? styles.activatedTitle : styles.title, style = {};
    return (
      <div className="col s6 m4" ref="tab">
        <div style={{display: "flex", padding: "8px 0"}}>
          <div className={titleStyle} ref="title" draggable="true" data-type="shared"
               onDragOver={e => this.preventDefault(e)} onDrop={e => this.handleDrop(e)}
               onDragEnter={e => this.handleDragEnter(e)} onDragLeave={e => this.handleDragLeave(e)}
               onDragStart={e => this.handleDragStart(e)} onDragEnd={e => this.handleDragEnd(e)}
               onClick={() => this.props.onTabClick(this.props.tab.persistenceId)}>{this.props.tab.title}</div>
          <div className={styles.actions}>
            <div ref="actions">
              <i className="icon-close" onClick={() => this.remove()}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/tab/sharedTab.jsx